import {ErrorHandler, NgModule} from '@angular/core';
import {ErrorsHandler} from './errors-handler';

@NgModule({
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler,
    }
  ]
})
export class ErrorsHandleModule { }
